import { ECollectionPageType } from '@src/pages/[...slug]/components/collection/services/collectionService/CollectionService.types'

// Slug types
export const SLUG_TYPE = {
  COLLECTION: 'collection',
  SUBCOLLECTION: 'subcollection',
} as const

export type SlugType = (typeof SLUG_TYPE)[keyof typeof SLUG_TYPE]

// Feature flag types
export const FEATURE_FLAG_TYPE = {
  COLLECTION: 'collection',
  NONE: 'none',
} as const

// URL placement types
export const URL_PLACEMENT = {
  PATH: 'path',
  QUERY: 'query',
} as const

// Filter types
export const FILTER_TYPE = {
  DRAWER: 'drawer',
  SIDEBAR: 'sidebar',
  DROPDOWN: 'dropdown',
  BOTTOM_SHEET: 'bottom-sheet',
  MODAL: 'modal',
} as const

// Type-safe literal types
export type FeatureFlagType = (typeof FEATURE_FLAG_TYPE)[keyof typeof FEATURE_FLAG_TYPE]
export type UrlPlacement = (typeof URL_PLACEMENT)[keyof typeof URL_PLACEMENT]
export type FilterType = (typeof FILTER_TYPE)[keyof typeof FILTER_TYPE]
export type DesktopFilterType = typeof FILTER_TYPE.DRAWER | typeof FILTER_TYPE.SIDEBAR | typeof FILTER_TYPE.DROPDOWN
export type MobileFilterType = typeof FILTER_TYPE.BOTTOM_SHEET | typeof FILTER_TYPE.MODAL

export interface CollectionServerSideFeatureFlags {
  featureFlagType: typeof FEATURE_FLAG_TYPE.COLLECTION
  subCollectionUrlPlacement: UrlPlacement
  collectionPageType: ECollectionPageType
  filterType: FilterType
  isPersonalized: boolean
  isDynamicCollection: boolean
  bestSellerExperimentBucket: string | null
  clpFilterExperimentBucketMobile: string | null
  clpFilterExperimentBucketDesktop: string | null
}

export interface ServerSideFeatureFlagsNone {
  featureFlagType: typeof FEATURE_FLAG_TYPE.NONE
  isPersonalized: boolean
}

export type ServerSideFeatureFlags = CollectionServerSideFeatureFlags | ServerSideFeatureFlagsNone
